const banner = document.querySelector<HTMLElement>('.stickybanner');

if (banner?.querySelector('.stickybanner-content')) {
  const getCookie = (name: string): string | null => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  };

  const setStickyCookie = (value: 'open' | 'close'): void => {
    document.cookie = `sticky=${value};max-age=${24 * 60 * 60};path=/`;
  };

  const sticky = getCookie('sticky');
  if (sticky === 'open') {
    banner.style.display = 'block';
  } else if (sticky === 'close') {
    banner.style.display = 'none';
  } else {
    setStickyCookie('open');
  }

  banner.querySelector<HTMLAnchorElement>('a.close')?.addEventListener('click', (e: MouseEvent) => {
    e.preventDefault();
    banner.style.display = 'none';
    setStickyCookie('close');
  });
}
